import { append, head, init, last, prepend, tail } from 'ramda';
import { combineReducers } from 'redux';
import {
  ASSIGN_TIP,
  CANCEL_TIPPING,
  NEXT_TIPPING_BARBER,
  PREVIOUS_TIPPING_BARBER,
  RESET_TIPPING_BARBERS,
  SET_ADJUSTMENTS,
  SET_PROCESSING,
  SET_TIPPING_BARBERS,
  SET_TIPS,
} from './constants';
import { ADD_ITEM } from '../order/constants';
import valueReducer from '../../common/reducers/valueReducer';

const initialBarbersState = {
  current: {},
  prev: [],
  next: [],
};

const barbers = (state = initialBarbersState, { type, payload }) => {
  switch (type) {
    case RESET_TIPPING_BARBERS:
      return initialBarbersState;
    case SET_TIPPING_BARBERS:
      return {
        prev: [],
        current: head(payload),
        next: tail(payload),
      };
    case PREVIOUS_TIPPING_BARBER:
      return {
        prev: init(state.prev),
        current: last(state.prev),
        next: prepend(state.current, state.next),
      };
    case NEXT_TIPPING_BARBER:
      return {
        prev: append(state.current, state.prev),
        current: head(state.next),
        next: tail(state.next),
      };
    case ASSIGN_TIP:
      return {
        ...state,
        current: {
          ...state.current,
          tipAmount: payload.amount,
          paymentId: payload.paymentId,
          type: payload.type,
        },
      };

    default:
      return state;
  }
};

const initialTips = {};
const tips = (state = initialTips, { type, payload }) => {
  switch (type) {
    case RESET_TIPPING_BARBERS:
    case CANCEL_TIPPING:
    case SET_TIPPING_BARBERS:
    case ADD_ITEM:
      return initialTips;
    case ASSIGN_TIP:
      return {
        ...state,
        [payload.barberId]: payload,
      };
    case SET_TIPS:
      return payload || {};
    default:
      return state;
  }
};

const adjustments = valueReducer(null, SET_ADJUSTMENTS);

const processing = valueReducer(false, SET_PROCESSING);

const tipping = combineReducers({
  barbers,
  tips,
  processing,
  adjustments,
});

export default tipping;
